// src/components/Tour.js
import React, { useEffect, useState } from "react";
import "./Tour.css";

const steps = [
  {
    selector: ".create-btn",
    title: "Upload your file!",
    content:
      "Press any of our upload buttons and select the video file you want to edit.",
  },
  {
    selector: ".sidebar-section",
    title: "Your file will show up here!",
    content:
      "All videos processing and ready will show up here in the sidebar.",
  },
  {
    selector: ".ev-app-name",
    title: "Try our different models",
    content:
      "Here you can select between all of EditVibe’s different AI models.",
  },
];

export default function Tour({ run, onFinish }) {
  const [step, setStep] = useState(0);

  // reset on rerun
  useEffect(() => {
    if (!run) setStep(0);
  }, [run]);

  if (!run || step >= steps.length) return null;

  const { selector, title, content } = steps[step];
  const target = document.querySelector(selector);
  if (!target) return null;

  const rect = target.getBoundingClientRect();
  const tooltipWidth = 300; // must match Tour.css
  let style = {};
  let placementClass = "";

  if (selector === ".sidebar-section") {
    // ► place to the right, vertically centered on the sidebar section
    const shiftDown = 10; // extra vertical bump
    const top = rect.top + window.scrollY + rect.height / 2 - 40 + shiftDown;
    const left = rect.right + window.scrollX + 12; // 12px gap
    style = { top: `${top}px`, left: `${left}px` };
    placementClass = "placement-left";
  } else {
    // ▼ default: below & centered
    const baseLeft =
      rect.left + window.scrollX + rect.width / 2 - tooltipWidth / 2;
    const extraShift = selector === ".create-btn" ? 150 : 0;
    style = {
      top: `${rect.bottom + window.scrollY + 8}px`,
      left: `${baseLeft - extraShift}px`,
    };
  }

  const advance = (e) => {
    e.stopPropagation();
    if (step + 1 < steps.length) {
      setStep(step + 1);
    } else {
      onFinish();
    }
  };

  return (
    <div className="tour-overlay" onClick={advance}>
      <div
        className={[
          "tour-tooltip",
          selector === ".sidebar-section" ? "placement-left"   : "",
          selector === ".ev-app-name"     ? "placement-model" : ""
        ].join(" ")}
        style={style}
        onClick={(e) => e.stopPropagation()}
      >
        <h3>{title}</h3>
        <p>{content}</p>
        <button onClick={advance}>
          {step + 1 === steps.length ? "Done" : "Next"}
        </button>
      </div>
    </div>
  );
}
